import { isNotEmpty } from '@doltech/utils/lib/text';
import { types as t } from 'mobx-state-tree';

export const Sentence = t
  .model('Sentence', {
    key: t.number,
    text: t.string,
  })
  .actions((self) => ({
    setText(newText: string) {
      self.text = newText;
    },
  }))
  .views((self) => ({
    get hasValue() {
      return isNotEmpty(self.text);
    },
  }));

export const defaultSentences = [
  { key: 0, text: '' },
  { key: 1, text: '' },
  { key: 2, text: '' },
];
